// eslint-disable-next-line import/prefer-default-export
export const boxShadow = {
  sm: '0px 2px 2px rgba(0, 0, 0, 0.15)',
  md: '0px 4px 4px rgba(0, 0, 0, 0.15)',
  lg: '0px 8px 8px rgba(0, 0, 0, 0.15)',
};
